import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import StudentsTable from '@app/components/parents/Children/StudentsTable'
import Loader from '@app/components/ui/placeholders/Loader'
import * as parentActions from '@app/actions/parents'
import _ from 'lodash'

class ChildrenContainer extends Component {
  componentDidMount() {
    this.props.boundActions.fetchChildrenIfNeeded()
  }

  render() {
    const { students, student, olympiads, boundActions, event } = this.props
    if (!students.updatedOn) { return <Loader /> }

    return (
      <StudentsTable
        config={{
          mode: "parent",
          deleteEnabled: true,
          event: event
        }}
        students={_.values(students.objects)}
        student={student}
        olympiads={olympiads}
        updatedOn={students.updatedOn}
        createStudentAction={boundActions.addChild}
        updateStudentAction={boundActions.updateChild}
        deleteStudentAction={boundActions.deleteChild}
      />
    )
  }
}

const mapStateToProps = (state) => {
  const { parents: { children, child }, global: { event, olympiads } } = state;
  return { students: children, student: child, olympiads, event }
}

const mapDispatchToProps = (dispatch) => {
  let boundActions = bindActionCreators(parentActions, dispatch)
  return { boundActions }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChildrenContainer)
